// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"SupportNewMessage_formContainer__2kfrP","formHolder":"SupportNewMessage_formHolder__3sLyw"};